import { render, staticRenderFns } from "./MsgTable.vue?vue&type=template&id=18f6e04e&scoped=true"
import script from "./MsgTable.vue?vue&type=script&lang=js"
export * from "./MsgTable.vue?vue&type=script&lang=js"
import style0 from "./MsgTable.vue?vue&type=style&index=0&id=18f6e04e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f6e04e",
  null
  
)

export default component.exports